import React, { useMemo, type PropsWithChildren } from 'react';

import { Content } from '../content/Content';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import { type ALLOWED_FEATURES_TYPE, type AllowedFeatures } from '../features';
import { EMBEDDED_CONFLUENCE_CONTENT_TYPE } from '../page-common/EmbeddedConfluenceContentType';
import { EMBEDDED_CONFLUENCE_MODE } from '../page-common/EmbeddedConfluenceMode';
import type { PageCommonProps } from '../page-common/PageCommonProps';
import { isInEditorTemplatesPanelEnabled } from '../page-common/utils/isInEditorTemplatesPanelEnabled';

const IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';

export type EditPageProps = PropsWithChildren<
	PageCommonProps & {
		allowedFeatures?: AllowedFeatures<ALLOWED_FEATURES_TYPE.EDIT>;
		allowedTemplates?: string[];
		contentId: string;
		draftShareId?: string;
		parentProduct: string;
	}
>;

export const EditPage = (props: EditPageProps): React.JSX.Element => {
	const { allowedFeatures } = props;

	const contentConfiguration = useMemo(() => {
		const isTemplateBrowserEnabled = isInEditorTemplatesPanelEnabled(allowedFeatures);

		const queryParams = isTemplateBrowserEnabled
			? { inEditorTemplatesPanel: IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED }
			: undefined;

		return {
			experiences: {
				experience: ExperienceNames.EDIT_PAGE,
				ccExperience: ExperienceNames.CC_EDIT_PAGE_EMBED,
			},
			queryParams,
		};
	}, [allowedFeatures]);

	return (
		<Content
			{...props}
			contentType={EMBEDDED_CONFLUENCE_CONTENT_TYPE.PAGE}
			mode={EMBEDDED_CONFLUENCE_MODE.EDIT_MODE}
			contentConfiguration={contentConfiguration}
		/>
	);
};
